import axiosApi from '@/api/axiosApi';

export const submit = (data) => {
    return axiosApi({
        url: '/intserv/registration/add',
        method: 'post',
        data
    })
}